import HundredBricksAPIError from '../../../HundredBricksAPIError';
class OverviewReportError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('OverviewReportError', ...args);
    }
}
export default OverviewReportError;
